/**
 * Timer threshold constants and utilities for VDP unlock timer
 */

/** Maximum time (in seconds) to show timer when purchase is pending */
export const TWO_HOURS_IN_SECONDS = 60 * 60 * 2;

/** Maximum time (in seconds) to show timer for exclusive preview */
export const FORTY_EIGHT_HOURS_IN_SECONDS = 60 * 60 * 48;

/**
 * Calculate maximum time threshold based on purchase state
 * @param purchasePending - Whether a purchase is pending
 * @returns Maximum time in seconds before timer should be hidden
 */
export function getMaxTimerThreshold(purchasePending: boolean): number {
  return purchasePending ? TWO_HOURS_IN_SECONDS : FORTY_EIGHT_HOURS_IN_SECONDS;
}

/**
 * Calculate time remaining until vehicle becomes available
 * @param availableDateTime - Timestamp when vehicle becomes available (in milliseconds)
 * @returns Time remaining in milliseconds (can be negative if time has passed)
 */
export function getTimeRemaining(availableDateTime: number): number {
  return availableDateTime - Date.now();
}
